import TickList from './TickList'

export default TickList
